import translateKeys from './translateKeys';
import translateValues from './translateValues';
export default function translate() {
  let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let translatedQuery = {
    ...query
  };
  translatedQuery = translateKeys(translatedQuery, options);
  translatedQuery = translateValues(translatedQuery, options);
  return translatedQuery;
}